(function(Shop, $, undefined) {
  
  var bindUIActions = function() {
    $('#shopify-section-social-slider').insertBefore('[data-social-anchor]').addClass('active');
    $('#shopify-section-social-slider-plus').insertBefore('[data-social-anchor]').addClass('active');

    $('[data-radio-feature]').on('click', function(e) {
      var radioId = $(this).attr('data-radio-feature');
      var radioUrl = $(this).attr('data-url');
      var variantQty = $(this).attr('data-variant-quantity');
      var variantId = $(this).attr('data-variant-id');
      var variantPrice = $(this).attr('data-variant-price');
      var variantTitle = $(this).attr('data-variant-title');
      var productId = $(this).attr('data-product-id');
      var productTitle = $(this).attr('data-product-title');

      $(this).closest('.radio-feature__radios').find('.radio-feature__radio-btn').removeClass('radio-feature__radio-btn--selected');
      $(this).find('.radio-feature__radio-btn').addClass('radio-feature__radio-btn--selected');
      $(this).closest('.radio-feature').find('.radio-feature__image').hide();
      $(this).closest('.radio-feature').find('.radio-feature__image[data-radio-feature="' + radioId + '"]').show();

      $('[add-to-cart-radio]').attr({
        'data-variant-quantity': variantQty,
        'data-variant-id': variantId,
        'data-variant-price': variantPrice,
        'data-variant-title': variantTitle,
        'data-product-id': productId,
        'data-product-title': productTitle
      })

      $('[radio-link]').attr('href', radioUrl);
    })
  }

  var checkSelectedProductParam = function() {
    if (queryParams.product === "25") {
      $('[data-radio-feature="8436320131"]').trigger('click');
    }
  }

  Shop.init = function() {
    bindUIActions();
    checkSelectedProductParam();
  }

}(window.Shop = window.Shop || {}, jQuery));